import { ICommandBase } from '@/commands/interface/iCommandBase';
import { TextLayer } from '@/model/document2/page/surface/design/layer/textLayer';
import { D3TextLayer } from '@/model/document2/page/surface/design/layer/d3TextLayer';

// テキストレイヤーの文字列変更コマンド
export class ChangeTextCommand implements ICommandBase
{
    private layer! : TextLayer;
    private text! : string;
    private doneCallback! : () => void;

    private oldText;
    private oldObject;
    private newObject;

    constructor(layer : TextLayer, text : string, doneCallback : () => void)
    {
        this.layer = layer;
        this.text = text;
        this.doneCallback = doneCallback;

        // 現在のレイヤーを保持
        this.oldText = layer.text;
        this.oldObject = layer.getBackupTextObject();
    }

    public do() : void
    {
        this.layer.changeText(this.text);
        this.newObject = this.layer.getBackupTextObject();
        
        this.doneCallback();
    }

    public undo() : void
    {
        // プロパティに前の値を設定
        this.layer.text = this.oldText;
        this.layer.setBackupTextObject(this.oldObject);

        this.doneCallback();
    }

    public redo() : void
    {
        this.layer.changeText(this.text);
        this.layer.setBackupTextObject(this.newObject);

        this.doneCallback();
    }
}